import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment-timezone'
import('moment/locale/ru')
import VueMoment from 'vue-moment'

Vue.config.productionTip = false

Vue.use(VueMoment, {moment})

Vue.filter('numberDigits', number => {
  return number.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
})

new Vue({
  router,
  store,
  mounted() {
    store.dispatch('getCities')
    store.dispatch('getSymptoms')
  },
  render: h => h(App)
}).$mount('#app')
